/**
 * Ashley / Guide entry point — permanent home on Floating Home Button long-press.
 * Phase 1: launches existing guide briefing overlay in App.js.
 */

export const ASHLEY_GUIDE_OPEN_EVENT = "cp-ashley-guide-open";

export function launchAshleyGuide() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  window.dispatchEvent(new CustomEvent(ASHLEY_GUIDE_OPEN_EVENT));
}
